import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: null,
    voen: null,
    person: null,
    personDetails: null,
    selectedIndustryCategory: null,
}

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setToken(state, action) {
            state.token = action.payload;
        },
        setVoen(state, action) {
            state.voen = action.payload;
        },
        setPerson(state, action) {
            state.person = action.payload;
        },
        setPersonDetails(state, action) {
            state.personDetails = action.payload;
        },
        setIndustryCategory(state, action) {
            state.selectedIndustryCategory = action.payload;
        },
        clearAll(state) {
            state.token = null;
            state.person = null;
            state.personDetails = null;
            state.pin = null;
            state.voen = null;
            state.selectedIndustryCategory = null;
        }
    }
});

export const { setToken, setVoen, setPerson, setPersonDetails, clearAll, setIndustryCategory } = loginSlice.actions;

export default loginSlice.reducer;
